import React, { useEffect, useState, useCallback, useRef } from "react";
import api from "../../_services/api";
import { useParams } from "react-router";
import Carousel from "react-bootstrap/Carousel";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "../../components/Filter";
import notify from "../../components/UI/toast";
import UIInfiniteScroll from "../../components/UI/InfiniteScroll/InfiniteScroll";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import CardProduct from "../../components/CardProduct";
import Title from "../../components/Title";
import ImageBreak from "../../assets/404-banner.png";
import { Banner, Label, PageWrap, ListingLayout, TitleWrap } from "./styles";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useOpen } from "../../hooks/Open";
import {
  setBrandsCategory,
  selectRangeSlide,
  setBorderPrices,
  toggleCheckCategory,
  selectCategories,
  fetchBrands,
  clearCheckBrand,
  clearCheckCategories,
  setRangeSlide,
  resetFilters
} from "../../Redux/filterSlice";
import { clientesApi, configApi } from "page/OrderResumePag/_services/api";
import { useBannerTracking } from "../../hooks/useBannerTracking";
import { trackViewItemListMarketplace, trackSelectItemMarketplace, trackAddToWishlistMarketplace } from "../../utils/gtm";

export default function Product() {
  const [products, setProducts] = useState([]);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newPage, setNewPage] = useState(0);
  const [acceptNextPage, setAcceptNextPage] = useState(false);
  const [limit, setLimit] = useState(50);
  const [order, setOrder] = useState("price_desc");
  const categories = useSelector(selectCategories);
  const [categoriesFilter, setCategoriesFilter] = useState([]);
  const [count, setCount] = useState(0);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [lastId, setLastId] = useState("");
  const rangeSlide = useSelector(selectRangeSlide);
  const [hasSetPriceRange, setHasSetPriceRange] = useState(false);
  const selectedCategoryLabel = categories.find((c) => c.check)?.label;
  const firstBannerSent = useRef(false);
  const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
  
  const { handleBannerView, handleBannerClick, userInteraction, setUserInteraction } = useBannerTracking(
    banners,
    channel,
    firstBannerSent
  );

  const { id } = useParams();
  const brandIds = location.state?.brandIds || [id];

  const jwt = useUserData();

  const label = products[0]?.brand_name;
  const dataUser = jwt.userData?.data;

  const disp = useDispatch();

  const cpf = dataUser?.cpf;

  const navigate = useNavigate();
  const { closeAllMenu } = useOpen();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const idsFromQuery = query.get("ids");
    const brandIds = idsFromQuery
      ? idsFromQuery.split(",")
      : [id];

    closeAllMenu();
    disp(resetFilters());
    disp(fetchBrands({ id, newPage: 0, limit, cpf, brandIds }));
  }, [id, disp, cpf]);

  useEffect(() => {
    disp(clearCheckBrand());
    disp(clearCheckCategories());
    localStorage.removeItem("orderFilter");
    setNewPage(0);
    setProducts([]);
    setCount(0);
    setHasSetPriceRange(false);
  }, [id]);

  function onClickCategory(idCategory) {
    for (let i in categories) {
      if (idCategory === categories[i].id) {
        disp(
          toggleCheckCategory({
            id: idCategory,
          })
        );
        break;
      }
    }

    const categoriesFilterArray = [];
    for (let i in categories) {
      if (categories[i].check === true) {
        categoriesFilterArray.push(categories[i].id);
      }
    }
    setCategoriesFilter(() => categoriesFilterArray);
  }

  function onClickApplyFilter() {
    setNewPage(0);
    setHasSetPriceRange(true);
    setAcceptNextPage(false);
    setProducts([]);
    setCount(count + 1);
  }

  function onClickClearFilter() {
    disp(resetFilters());
    disp(clearCheckBrand());
    disp(clearCheckCategories());

    setCategoriesFilter([]);
    setNewPage(0);
    setProducts([]);
    setCount((prev) => prev + 1); // força recarregar
    setHasSetPriceRange(false);
  }

  function loadParams() {
    const param = {};
    param.partner_customer_id = dataUser?.cpf;
    param.brand_uuid = id;
    param.page = newPage;
    param.limit = limit;
    param.order = order;
    if (categoriesFilter.length > 0) {
      param.category_uuid = categoriesFilter;
    }
    if (rangeSlide.length > 0) {
      param.min_price = rangeSlide[0];
      param.max_price = rangeSlide[1];
    }
    return param;
  }

  async function fetchMore() {
    setNewPage((prev) => prev + 1);
  }

  const onImageError = (e) => {
    e.target.src = ImageBreak;
  };

  function getBannerOrder(filename) {
    const name = filename.split('/').pop();
    const match = name.match(/^(\d+)-/);
    return match ? parseInt(match[1], 10) : Infinity;
  }

  async function apiWishlist() {
    if (!dataUser?.cpf) {
      console.warn("CPF não encontrado no dataUser, retornando array vazio para wishlist");
      return [];
    }
    
    try {
      const response = await clientesApi.get(
        `/customer/${dataUser.cpf}/wishlist`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao buscar wishlist:", error);
      return [];
    }
  }

  async function getBanner() {
    try {
      const response = await configApi.get(
        `/banners/actives/marca/${id}`
      );
      return response.data;
    } catch (err) {
      notify("Erro ao carregar home", "error");
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoadingProducts(true);
      const wishlist = await apiWishlist();

      if (lastId !== id) setLoading(true);
      if (typeof cpf !== "undefined") {

        const query = new URLSearchParams(location.search);
        const idsFromQuery = query.get("ids");
        const brandIds = idsFromQuery
          ? idsFromQuery.split(",")
          : [id];

        disp(fetchBrands({ id, newPage, limit, cpf, brandIds }))
          .then((payload) => {
            const response = payload.payload;
            let pageCount;
            
            if (!response.data || response.data.length === 0 || response.total === 0) {
              if (newPage === 0) {
                setProducts([]);
              }

              setAcceptNextPage(false);
              pageCount = 0;
              setLoadingProducts(false);
              setLoading(false);
              return;
            } else {
              pageCount = Math.ceil(response.total / response.per_page);
              if (!hasSetPriceRange && newPage === 0) {
                const minPrice = Math.round((Number(response.price_min) + Number.EPSILON) * 100) / 100;
                const maxPrice = Math.round((Number(response.price_max) + Number.EPSILON) * 100) / 100;
                disp(setBorderPrices({
                  lowerValue: minPrice,
                  greaterValue: maxPrice,
                }));

                disp(setRangeSlide({ value: maxPrice }));
                setHasSetPriceRange(true);
              }
            }

            // Buscar banners em outro endpoint
            // const banners = (response?.banners || []).sort(
            //   (a, b) => getBannerOrder(a.filename) - getBannerOrder(b.filename)
            // );
            // setData(banners); 

            const currentPageNumber = response.page || (newPage + 1);
            const isLastPage = currentPageNumber >= pageCount || response.data.length < response.per_page;

            if (isLastPage) {
              setAcceptNextPage(false);
            } else {
              setAcceptNextPage(true);
            }

            const productsWithWishlist = response.data.map((product) => {
              return {
                ...product,
                wishlist: wishlist.some((item) => item.product_uuid === product.uuid),
              };
            });

            if (response.data && response.data.length > 0) {
              if (newPage === 0) {
                setProducts(productsWithWishlist);
              } else {
                setProducts(prevProducts => [...prevProducts, ...productsWithWishlist]);
              }

              if (newPage === 0) {
                const listName = productsWithWishlist[0]?.brand_name || id;
                trackViewItemListMarketplace({
                  itemListName: listName,
                  items: productsWithWishlist.map((p, i) => ({
                    product: p,
                    index: i,
                  })),
                });
              }
            }

            setLoadingProducts(false);
            setLoading(false);
            setLastId(id);
          })
          .catch((err) => {
            console.log(err);
            
            if (newPage === 0) {
              setProducts([]);
            }

            setAcceptNextPage(false);
            setLoadingProducts(false);
            setLoading(false);
            notify("Erro ao tentar carregar produtos", "error");
          });
      }
    };
    fetchData();
  }, [id, newPage, count, cpf]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const data = await getBanner();
        setBanners(data.data || data); 
      } catch (error) {
        console.error("Erro ao buscar banners:", error);
      }
    };

    fetchBanners();
  }, []);

  if (loading) return <LoaderSmall />;

  return (
    <>
      <div className="wl-page">
        <TitleWrap>
          <div className="px-4 pt-4">
            {label && <Title titleClass="text-left width-100" label={label} />}
          </div>
        </TitleWrap>

        {banners.length > 0 && (
          <Banner>
            <Carousel 
              onSlide={handleBannerView}
              onMouseDown={() => setUserInteraction(true)}
              onTouchStart={() => setUserInteraction(true)}
            >
              {banners?.map((item, index) => {
                return (
                  <Carousel.Item key={`banner-${index}`}>
                    <a href={item?.uri} onClick={() => handleBannerClick(index)}>
                      <img
                        className=" w-100"
                        src={item?.s3_file}
                        alt={item?.s3_file}
                        onError={onImageError}
                      />
                    </a>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </Banner>
        )}

        <PageWrap>
          <Container className="pt-4">
            <ListingLayout>
              <Filter
                target={"Categorias"}
                onClickCategory={onClickCategory}
                onClickApplyFilter={onClickApplyFilter}
                onClickClearFilter={onClickClearFilter}
              />

              <div className="product-area">
                <Row className="mt-4 product-grid">
                  {(!products.length && !loading && !loadingProducts) && (
                    <Container>
                      <div style={{ textAlign: "center" }}>
                        <h6 className="empty-favorites__title" style={{ fontSize: "24px", fontWeight: "600" }}>
                          {selectedCategoryLabel
                            ? `Não encontramos produtos em ${selectedCategoryLabel}`
                            : "Não encontramos produtos"
                          }
                        </h6>
                        <p className="empty-favorites__description">
                          Parece que ainda não temos nada por aqui. Mas nossa vitrine está cheia de outras opções que você pode gostar.
                        </p>
                      </div>
                      <button
                        className="btn-default-wl btn btn-primary text-xs empty-favorites__button"
                        onClick={onClickClearFilter}
                        type="button"
                      >
                        VOLTAR PARA VITRINE
                      </button>
                    </Container>
                  )}

                  {products.map((product, index) => {
                    const { uuid, label } = product;
                    const brandName = product.brand_name || id;
                    const priceFormatted = {
                      BRL: {
                        offer: product?.product_price?.price ?? 0,
                        price: product?.product_price?.price_suggested !== product?.product_price?.price ? product.product_price.price_suggested : null
                      },
                      points: {
                        offer: Math.round(product?.product_price?.points_suggested) ?? 0,
                        price: product?.product_price?.points !== product?.product_price?.points_suggested ? Math.round(product.product_price.points) : null
                      },
                    };

                    return (
                      <Col xs={6} key={uuid} className="pb-4">
                        <CardProduct
                          id={uuid}
                          label={label}
                          image={product.images[0]?.path}
                          price={priceFormatted}
                          campaign=""
                          wishlist={product?.wishlist}
                          cashback=""
                          searchColorButton={false}
                          onProductClick={() => trackSelectItemMarketplace({
                            product,
                            itemListName: brandName,
                            index: index,
                          })}
                          onAddToWishlist={() => trackAddToWishlistMarketplace({
                            product,
                            itemListName: brandName,
                            index: index,
                          })}
                        />
                      </Col>
                    );
                  })}

                  {products && acceptNextPage && (
                    <UIInfiniteScroll fetchMore={() => fetchMore()} />
                  )}
                </Row>

                {loadingProducts && (
                  <div className="text-center mb-5">
                    <span className="spinner-border color-wl" role="status" />
                  </div>
                )}
              </div>
            </ListingLayout>
          </Container>
        </PageWrap>
      </div>
    </>
  );
}
